import { useEffect, useRef } from 'react';

import {
	getLoomProvider,
	type LoomProviderConfig,
} from '@confluence/fabric-providers/entry-points/getLoomProvider';
import { useLoomEntryPointVariant } from '@confluence/loom-utils';

import type { EditorAPI } from '../loomEditorUtils-types';

type UseInitializeLoomPlugin = {
	loomPlugin?: EditorAPI['loom'];
	providerConfig: LoomProviderConfig;
};

export const useInitializeLoomPlugin = ({
	loomPlugin,
	providerConfig,
}: UseInitializeLoomPlugin) => {
	const hasInitialized = useRef(false);

	const { entryPointVariant } = useLoomEntryPointVariant();
	const isLoomRecordingEligible = ['BETA', 'CO_USE'].includes(entryPointVariant);

	const initLoom = loomPlugin?.actions.initLoom;

	useEffect(() => {
		if (!hasInitialized.current && initLoom && isLoomRecordingEligible) {
			hasInitialized.current = true;
			void initLoom({ loomProvider: getLoomProvider(providerConfig) });
		}
	}, [initLoom, isLoomRecordingEligible, providerConfig]);
};
